"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _slice = _interopRequireDefault(require("./slice"));

var _default = (0, _unmutable.default)({
  name: 'take',
  immutable: 'take',
  all: function all(amount) {
    return (0, _slice.default)(0, amount);
  }
});

exports.default = _default;